<template>
  <div>
  <el-dialog
      :title="$t('posts.dialog.selectModelTitle')"
      :visible.sync="modalShowModels"
      width="30%"
  >
              <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="setModalShowModels(false)">OK</el-button>
              </span>
  </el-dialog>
  <el-dialog
      :title="$t('posts.dialog.createFromModelTitle')"
      :visible.sync="modalUseModel"
      width="30%"
  >
    <span>{{ $t('posts.dialog.createFromModelText') }}</span>
    <br>
    <br>
    <el-input v-model="referenceDupli"
              :placeholder="$t('posts.dialog.selectReferencePlaceholder')"
              :label="$t('posts.dialog.selectReference')"></el-input>
    <span slot="footer" class="dialog-footer">
                  <el-button @click="setModalUseModel(false)">{{ $t('posts.dialog.cancel') }}</el-button>
                  <el-button type="primary" @click="dupliquer(currentId)">{{ $t('posts.dialog.confirm') }}</el-button>
    </span>
  </el-dialog>
  <dialog-change-contact-multiple-posts
      :selected="selection"
  >
  </dialog-change-contact-multiple-posts>
  <el-dialog
      :title="$t('posts.dialog.duplicateTitle')"
      :visible.sync="modalDuplicate"
      width="30%"
  >
    <span>{{ $t('posts.dialog.duplicateText') }}</span>
    <br>
    <br>
    <el-input v-model="referenceDupli"
              :placeholder="$t('posts.dialog.duplicatePlaceholder')"
              :label="$t('posts.dialog.duplicateReference')"></el-input>
    <span slot="footer" class="dialog-footer">
                  <el-button @click="setModalDuplicate(false)">{{ $t('posts.dialog.cancel') }}</el-button>
                  <el-button type="primary" @click="dupliquer(currentId)">{{ $t('posts.dialog.confirm') }}</el-button>
              </span>
  </el-dialog>

  <el-dialog
      :title="$t('posts.dialog.deleteTitle')"
      :visible.sync="modalDelete"
      width="30%"
  >
    <span>{{ $t('posts.dialog.deleteText') }}</span>
    <span slot="footer" class="dialog-footer">
                  <el-button @click="setModalDelete(false)">{{ $t('posts.dialog.cancel') }}</el-button>
                  <el-button type="primary" @click="supprimer(currentId)">{{ $t('posts.dialog.delete') }}</el-button>
              </span>
  </el-dialog>
  <el-dialog
      title="Confirmation de suppression :"
      :visible.sync="modalConfirmedDeleteList"
      width="30%"
  >
    <span class="text-left">{{ titreModalConfirmedDeleteList }}</span>
    <span slot="footer" class="dialog-footer">
                  <el-button @click="setModalConfirmedDeleteList(false)">Annuler</el-button>
                  <el-button v-if="selection.length == 1" type="danger"
                             @click="supprimer(selection)"> {{ $t('posts.list.delete') }}</el-button>
                  <el-button v-else type="danger"
                             @click="supprimerAll(selection)"> {{ $t('posts.list.delete') }}</el-button>
              </span>
  </el-dialog>
  </div>
</template>

<script>
import DialogChangeContactMultiplePosts from '@/pages/posts/List/Dialog/DialogChangeContactMultiplePosts'
import { deleteAllPosts, deletePost, duplicatePost, setAdsState } from '@/services/posts'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogsVo',
  components: {
    DialogChangeContactMultiplePosts
  },
  props: [
    'referenceDuplication',
    'modalConfirmedChangeContactList',
    'titreModalConfirmedDeleteList'
  ],
  computed: {
    ...mapState('postsVo', ['currentId', 'modalDelete', 'modalDuplicate', 'modalUseModel', 'modalShowModels', 'modalConfirmedDeleteList', 'selection']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  data () {
    return {
      referenceDupli: null
    }
  },
  beforeMount () {
    this.referenceDupli = this.referenceDuplication
  },
  methods: {
    ...mapMutations('postsVo', [
      'setModalDelete',
      'setModalDuplicate',
      'setModalShowModels',
      'setModalUseModel',
      'setModalConfirmedDeleteList',
      'setSelection',
      'setPage'
    ]),
    async dupliquer (id) {
      this.$ga.event('annonce', 'clic', 'annonce_dupliquer', this.sitimmoUser.id)
      let messageNotif = ''
      let typeNotif = ''

      const regexReference = RegExp('^[a-zA-Z0-9\\_\\-\\ \\.]+$')
      if (!(regexReference.test(this.referenceDupli))) {
        typeNotif = 'error'
        messageNotif = this.$t('validator.referenceMustBeWithoutAccentAndSpecialCharacter')
      } else {
        const postCreated = await duplicatePost(id, this.referenceDupli)
        if (postCreated.reference) {
          typeNotif = 'success'
          messageNotif = this.$t('posts.dialog.duplicateNotificationSuccess', { reference: postCreated.reference })
        } else if (postCreated.type == 'error') {
          typeNotif = 'error'
          messageNotif = postCreated.message
        } else {
          typeNotif = 'error'
          messageNotif = this.$t('posts.dialog.duplicateNotificationError')
        }

        if (postCreated.id) {
          const resp = await setAdsState(postCreated.id, 'SAISIE_VO', 'B')
          if (resp.type == 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            this.setLoadingStatus(false)
            return false
          }
        }
      }
      this.$message({
        message: messageNotif,
        type: typeNotif
      })

      if (this.modalUseModel == true) {
        this.resetFilter()
      }
      this.setPage(1)
      this.$store.dispatch('postsVo/loadPosts')
      this.setModalDuplicate(false)
      this.setModalUseModel(false)
    },
    async supprimer (id) {
      const callDelete = await deletePost(id)
      if (callDelete.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.setLoadingStatus(false)
        this.modalDelete = false
        return false
      }
      const type_notif = 'success'
      const message_notif = this.$t('posts.dialog.deleteNotification')
      this.$message({
        message: message_notif,
        type: type_notif
      })
      this.$store.dispatch('postsVo/loadPosts')
      this.selected = []
      this.setModalDelete(false)
      this.setModalConfirmedDeleteList(false)
    },
    async supprimerAll (annonces) {
      const callDelete = await deleteAllPosts(annonces)
      const type_notif = 'success'
      const message_notif = this.$t('validator.addDelete')
      this.$message({
        message: message_notif,
        type: type_notif
      })
      this.$store.dispatch('postsVo/loadPosts')
      this.setSelection([])
      this.setModalConfirmedDeleteList(false)
    }
  }
}
</script>
